import "util/print_debug";
import "vendors/segment";
import "vendors/google_maps";
import "vendors/pendo";
import { renderWithContext } from "apps/root";
import SignerRouter from "signer_portal/router";

renderWithContext(SignerRouter);
